import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
@Component({
    selector: 'email-template',
    templateUrl: './EmailTemplate.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTemplate {
  @Input() name: string = '';
  @Input() email: string = '';
  constructor(
    ) {
  }
}
